module.exports = __webpack_public_path__ + "img/mcafee-homepage.6cd92881.jpg";